export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    blob: p => p.secondaryLight,
    blobGradientStart: p => p.primaryLight,
    blobGradientEnd: p => p.primaryDark,
    backgroundColor: p => p.tertiaryDark,
    background: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    blob: p => p.tertiaryDark,
    blobGradientStart: p => p.primaryLight,
    blobGradientEnd: p => p.primaryDark,
    backgroundColor: p => p.tertiaryLight,
    background: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    blob: p => p.secondaryDark,
    blobGradientStart: p => p.primaryLight,
    blobGradientEnd: p => p.primaryDark,
    backgroundColor: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight
  }
}
